import BACKENDERROR from "app/static/frontend/imports/backenderror"

/**
 * This action creator is used is search table view to update row data
 * as well as calling a function which will send a PATCH request to update
 * an object to match the udpated row data
 * If the patch request fails, we will revert the row data to its initial state
 *
 * @param {Function} updateResourceTableRow updateResourceTableRow function from sheet-action-creators that has a dispatch argument applied
 * @param {String} tableId id of resource table where this function is being called
 * @param {Number} rowId id of row resource where this function is being called
 * @param {Function} patchValueFunction function to create and send PATCH request to update object
 * @param {Object} patchValueArgs argument to be passed to patchValueFunction
 * @param {Object} updateExtraObj how we want to update the _extra field of the row data
 * @param {Object} patchValueArgs how we want to revert the update of the _extra field of row data
 * @returns {null} this function is just used to send actions
 */
export const updateCellExtraAndPatchValue = async ({
    updateResourceTableRow,
    tableId,
    rowId,
    patchValueFunction,
    patchValueArgs,
    updateExtraObj,
    updateExtraRollbackObj,
}) => {
    // optimistically update resource table row
    updateResourceTableRow({
        tableId,
        datumId: rowId,
        updateArgs: { _extra: updateExtraObj },
    })
    try {
        await patchValueFunction(patchValueArgs)
    } catch (error) {
        BACKENDERROR(error)
        // set row back to how it was before we optimistically updated it
        updateResourceTableRow({
            tableId,
            datumId: rowId,
            updateArgs: { _extra: updateExtraRollbackObj },
        })
    }
}
